import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, mergeMap, catchError } from "rxjs/operators";
import { askOurDocsRoles } from "@shared/constants/roles/roles";
import { AuthService } from "@services/auth/auth.service";
import { AskOurDocsV2Service } from '../services/ask-our-docs-v2/ask-our-docs-v2.service';

@Injectable({
  providedIn: 'root'
})
export class AskOurDocsRoleGuard  {

  constructor(
    private authService: AuthService,
    private router: Router,
    private askOurDocsV2Service: AskOurDocsV2Service
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const indexName = route.params['indexName'];
    
    // First check if user has specific role for this repository
    return this.hasAskOurDocSpecificRepoRoleByIndexName(indexName).pipe(
      mergeMap(hasRole => {
        if (hasRole) {
          return of(true);
        }
        
        // If no role, check if it's a public repository
        return this.isPublicRepository(indexName).pipe(
          map(isPublic => {
            if (isPublic) {
              return true;
            } else {
              return this.router.createUrlTree(['/error']);
            }
          }),
          catchError(() => {
            // If error checking public repos, deny access
            return of(this.router.createUrlTree(['/error']));
          })
        );
      })
    );
  }

  hasAskOurDocsRoles() {
    return this.authService.userData$.pipe(
      map(userData => {
        return userData.roles?.some((role: string) => role.includes(askOurDocsRoles.IndexPrefix)) || false;
      })
    );
  }

  hasAskOurDocSpecificRepoRoleByIndexName(indexName: string): Observable<boolean> {
    return this.authService.userData$.pipe(
      map(userData => {
        return (indexName.includes(askOurDocsRoles.IndexPrefix) && userData.roles?.includes(indexName)) || false;
      })
    );
  }

  isPublicRepository(indexName: string): Observable<boolean> {
    return this.askOurDocsV2Service.fetchPublicRepositories().pipe(
      map(repositories => {
        return repositories.some(repo => repo.indexName === indexName);
      })
    );
  }

}

